"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.windowRedirect = exports.postalCodeLengthIsInvalid = exports.cvvLengthInvalid = exports.cardIsExpired = exports.postalCodeIsInvalid = exports.numbersOnly = exports.cityIsInvalid = exports.addressIsInvalid = exports.creditCardIsValid = exports.cardValidationRegEx = exports.getCardType = exports.encryptValues = exports.handleZuoraContactInfo = exports.getYears = exports.getFullPath = void 0;

var _queryString = _interopRequireDefault(require("query-string"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var getFullPath = function getFullPath(path) {
  // note: that dev environment also has the production flag
  var win = window;
  var baseUrl = process.env.NODE_ENV === 'development' ? '/api' : win['ss_env'].SSHUB_API_URL;
  return "".concat(baseUrl).concat(path);
}; ////////////// UTILS TO HANDLING DATE CREATION ////////////////////////////
// create a list of years for the billing form credit card year expiration dropdown


exports.getFullPath = getFullPath;

var getYears = function getYears() {
  var yearItems = [];
  var currentYear = new Date().getFullYear();

  for (var i = currentYear; i < currentYear + 30; i++) {
    yearItems.push({
      value: i.toString(),
      label: i.toString()
    });
  }

  return yearItems;
}; ////////////// UTILS TO HANDLING DATE CREATION END ////////////////////////////
// expecting the window.location.search for 1nd argument


exports.getYears = getYears;

var handleZuoraContactInfo = function handleZuoraContactInfo(windowSearch, cb) {
  var queries = _queryString.default.parse(windowSearch);

  var refId = queries && queries.refId || '';

  if (refId) {
    var creditCardAddress1 = queries.creditCardAddress1,
        creditCardAddress2 = queries.creditCardAddress2,
        creditCardPostalCode = queries.creditCardPostalCode,
        creditCardCity = queries.creditCardCity,
        creditCardCountry = queries.creditCardCountry,
        creditCardState = queries.creditCardState,
        _queries$field_passth = queries.field_passthrough2,
        contactStreetAddress = _queries$field_passth === void 0 ? '' : _queries$field_passth,
        _queries$field_passth2 = queries.field_passthrough5,
        contactAddress = _queries$field_passth2 === void 0 ? '' : _queries$field_passth2,
        companyName = queries.field_passthrough3,
        _queries$field_passth3 = queries.field_passthrough1,
        contactName = _queries$field_passth3 === void 0 ? '' : _queries$field_passth3,
        field_passthrough4 = queries.field_passthrough4;
    var isDiffContactAddress = field_passthrough4 === 'true';
    var name = contactName.split('/');
    var splitStreetAddress = contactStreetAddress.split('/'); // Order is: city/state/postalCode/country

    var splitAddress = contactAddress.split('/');
    var _contactInfo = {
      firstName: name[0],
      lastName: name[1],
      city: splitAddress[0],
      state: splitAddress[1],
      postalCode: splitAddress[2],
      country: splitAddress[3]
    };

    if (isDiffContactAddress) {
      var completeContactInfo = _objectSpread({}, _contactInfo, {
        companyName: companyName,
        address1: splitStreetAddress[0],
        address2: splitStreetAddress[1]
      });

      cb(completeContactInfo);
    } else {
      var _completeContactInfo = _objectSpread({}, _contactInfo, {
        companyName: companyName,
        address1: creditCardAddress1,
        address2: creditCardAddress2,
        postalCode: creditCardPostalCode,
        city: creditCardCity,
        country: creditCardCountry,
        state: creditCardState
      });

      cb(_completeContactInfo);
    }
  }
}; ////////////// UTILS FOR ZUORA BILLING FORM /////////////////////////////////////////////////////


exports.handleZuoraContactInfo = handleZuoraContactInfo;
/**
 * encrypt the text using the specified public key.
 * @param params the text to be encrypted on the form on an object.
 * @param publicKey the public key.
 * @returns Base64 encoded encrypted data.
 */

var encryptValues = function encryptValues(params, publicKey) {
  var creditCardExpirationMonth = params.creditCardExpirationMonth,
      creditCardExpirationYear = params.creditCardExpirationYear,
      creditCardNumber = params.creditCardNumber,
      cardSecurityCode = params.cardSecurityCode;
  var win = window;
  var pidCryptUtil = win && win['pidCryptUtil'];
  var pidCrypt = win && win['pidCrypt'];
  var unencryptedValues = '#' + creditCardNumber + '#' + cardSecurityCode + '#' + creditCardExpirationMonth + '#' + creditCardExpirationYear;

  if (pidCryptUtil && pidCrypt && publicKey) {
    try {
      var key = pidCryptUtil.decodeBase64(publicKey);
      var rsa = new pidCrypt.RSA();
      var asn = pidCrypt.ASN1.decode(pidCryptUtil.toByteArray(key));
      var tree = asn.toHexTree(); // setting the public key for encryption with retrieved ASN.1 tree

      rsa.setPublicKeyFromASN(tree); // Base64 encode and encrypt the string

      var crypted = rsa.encrypt(unencryptedValues);
      return pidCryptUtil.encodeBase64(pidCryptUtil.convertFromHex(crypted));
    } catch (e) {
      console.info(e);
    }
  }

  return '';
};

exports.encryptValues = encryptValues;

var getCardType = function getCardType(number) {
  if (!number) {
    return '';
  }

  var checkDigit = parseInt(number[0].concat(number[1]));
  var visaRegex = /4[0-9]/;
  var mcRegex = /5[1-5]/;
  var discRegex = /6[0,2,4,5]/;
  var amexRegex = /3[4,7]/;

  if (visaRegex.test(checkDigit)) {
    return 'Visa';
  } else if (mcRegex.test(checkDigit)) {
    return 'MasterCard';
  } else if (discRegex.test(checkDigit)) {
    return 'Discover';
  } else if (amexRegex.test(checkDigit)) {
    return 'AmericanExpress';
  } else {
    return 'Invalid';
  }
};

exports.getCardType = getCardType;
var cardValidationRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|62[0-9]{14})$/;
exports.cardValidationRegEx = cardValidationRegEx;

var creditCardIsValid = function creditCardIsValid(cardNumber) {
  if (cardNumber && cardNumber.length > 4) {
    var strippedCardNumber = cardNumber.replace(/\s/g, '');
    var visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
    var mastercardRegEx = /^(?:5[1-5][0-9]{14})$/;
    var amexpRegEx = /^(?:3[47][0-9]{13})$/;
    var discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;

    if (visaRegEx.test(strippedCardNumber)) {
      return true;
    } else if (mastercardRegEx.test(strippedCardNumber)) {
      return true;
    } else if (amexpRegEx.test(strippedCardNumber)) {
      return true;
    } else if (discovRegEx.test(strippedCardNumber)) {
      return true;
    }

    return false;
  }
};

exports.creditCardIsValid = creditCardIsValid;

var addressIsInvalid = function addressIsInvalid(address) {
  return !/^[^!@$%^&*(){}:"<>;'\_|]+$/.test(address);
};

exports.addressIsInvalid = addressIsInvalid;

var cityIsInvalid = function cityIsInvalid(city) {
  return !/^[A-Za-z\s]+$/.test(city);
}; //removes everything but numbers from string


exports.cityIsInvalid = cityIsInvalid;

var numbersOnly = function numbersOnly(stringWithAnyCharacter) {
  return stringWithAnyCharacter.replace(/\D/g, '');
};

exports.numbersOnly = numbersOnly;

var postalCodeIsInvalid = function postalCodeIsInvalid(postalCode) {
  return !/^[0-9\-]+$/.test(postalCode);
};

exports.postalCodeIsInvalid = postalCodeIsInvalid;

var cardIsExpired = function cardIsExpired(month, year) {
  var ccMonth = parseInt(month);
  var ccYear = parseInt(year);
  var currentMonth = new Date().getMonth() + 1;
  var currentYear = new Date().getFullYear();

  if (ccYear === currentYear && ccMonth <= currentMonth) {
    return true;
  } else if (ccYear < currentYear) {
    return true;
  }

  return false;
};

exports.cardIsExpired = cardIsExpired;

var cvvLengthInvalid = function cvvLengthInvalid(ccNum, cvvNum) {
  var cardType = '';

  if (ccNum) {
    cardType = getCardType(ccNum.replace(/\s/g, ''));
  }

  var cvvLength = 3;
  var cvv = "".concat(cvvNum);

  if (cardType === 'AmericanExpress') {
    cvvLength = 4;
  }

  if (cvv && cvv.length > 2) {
    return !(cvv.length === cvvLength);
  }

  return false;
};

exports.cvvLengthInvalid = cvvLengthInvalid;

var postalCodeLengthIsInvalid = function postalCodeLengthIsInvalid(country, postalCode) {
  var length = postalCode.length;

  switch (country) {
    case 'United States':
      return !(length >= 5 && length <= 10);

    case 'Canada':
      return !(length === 6);

    default:
      return true;
  }
}; ////////////// UTILS FOR ZUORA BILLING FORM  END /////////////////////////////////////////////////////
////////////// MISC UTILS  /////////////////////////////////////////////////////


exports.postalCodeLengthIsInvalid = postalCodeLengthIsInvalid;

var windowRedirect = function windowRedirect(url) {
  return window.location.replace(url);
}; ////////////// MISC UTILS END /////////////////////////////////////////////////////


exports.windowRedirect = windowRedirect;